import { useEffect, useState } from "react";
import api, { fmtDate, fmtMoney } from "../../api";
import Layout from "../../components/Layout";
import { toast } from "sonner";

const Wrapper = ({ embedded, children }) => (embedded ? <>{children}</> : <Layout title="Crew payables">{children}</Layout>);

export default function Payables({ embedded = false }) {
  const [data, setData] = useState(null);
  const load = () => api.get("/payables").then((r) => setData(r.data)).catch(() => toast.error("Could not load payables"));
  // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only load by design
  useEffect(() => { load(); }, []);

  const markPaid = async (r) => {
    await api.post(`/payables/${r.visit_id}/mark-paid`, r.team ? { sub_id: r.sub_id } : {});
    toast.success("Marked paid");
    load();
  };

  return (
    <Wrapper embedded={embedded}>
      {!data && <p className="text-muted-foreground">Loading…</p>}
      {data && (
        <>
          <div className="mb-6 grid grid-cols-2 gap-3" data-testid="payable-totals">
            {data.totals.map((t) => (
              <div key={t.sub_name} className="card-flat p-4">
                <p className="font-semibold">{t.sub_name}</p>
                <p className="text-sm text-destructive font-bold">Owes {fmtMoney(t.outstanding)}</p>
                <p className="text-xs text-muted-foreground">Paid {fmtMoney(t.paid)}</p>
              </div>
            ))}
            {data.totals.length === 0 && <p className="card-flat col-span-2 p-6 text-sm text-muted-foreground">No subcontractor jobs yet.</p>}
          </div>
          <div className="space-y-2" data-testid="payable-rows">
            {data.rows.map((r) => (
              <div key={`${r.visit_id}-${r.sub_id}`} className="card-flat flex items-center justify-between p-4" data-testid={`payable-${r.visit_id}-${r.sub_id}`}>
                <div>
                  <p className="font-semibold">{r.property_name} {r.team && <span className="rounded-full bg-secondary px-2 py-0.5 text-xs font-bold text-secondary-foreground">TEAM</span>}</p>
                  <p className="text-sm text-muted-foreground">{r.sub_name} · {fmtDate(r.date)}{r.hours ? ` · ${r.hours}h` : ""}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-bold">{fmtMoney(r.amount)}</span>
                  {r.paid
                    ? <span className="text-xs font-bold text-primary">PAID</span>
                    : <button data-testid={`pay-sub-${r.visit_id}-${r.sub_id}`} onClick={() => markPaid(r)} className="h-10 rounded-md bg-primary px-3 text-xs font-bold text-primary-foreground">Mark paid</button>}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </Wrapper>
  );
}
